import { render, staticRenderFns } from "./home.vue?vue&type=template&id=2efff55b&scoped=true&"
import script from "./home.vue?vue&type=script&setup=true&lang=js&"
export * from "./home.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./home.vue?vue&type=style&index=0&id=2efff55b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efff55b",
  null
  
)

export default component.exports